export default __webpack_public_path__ + "static/media/029-ship.0621de56.png";